module.exports = __webpack_public_path__ + "70525ad73200fce5b386213e674c1237.MP3";